import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuantum = (props) => /* @__PURE__ */ _jsx("svg", {
	className: "fc-icon",
	focusable: "false",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	"icon-name": "services-menu-quantum",
	color: "inherit",
	viewBox: "0 0 37 37",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#FF6700",
		d: "M28.5937 18.0455c.2719-.3232.5258-.6463.7592-.972 1.5388-2.1492 2.0184-4.0804 1.3131-5.3038-.5899-1.0207-2.0466-1.5824-4.065-1.5824-1.8799 0-4.247.4873-6.8604 1.5414-.6463-.3052-1.2901-.5796-1.9235-.8258 2.0414-.93868 4.0342-1.5901 5.8576-1.93633-1.2002-2.95448-2.9416-4.81642-4.8805-4.81642-2.0928 0-3.9547 2.1697-5.155 5.54478-3.5238-.64885-6.33468-.12053-7.38106 1.69267-1.12075 1.9415.04362 4.8959 2.73651 7.8145-.27186.3232-.52577.6489-.75915.9746-1.54136 2.1492-2.01838 4.0804-1.3131 5.3037 1.13871 1.9722 5.5089 2.2287 10.928.0385.6463.3052 1.2875.5796 1.9209.8258-2.0414.9361-4.0342 1.5849-5.8602 1.9312 1.2002 2.9596 2.9416 4.8241 4.8831 4.8241 2.0928 0 3.9547-2.1697 5.1549-5.5448 3.5213.6489 6.3348.1205 7.3811-1.6927 1.1208-1.9414-.0436-4.8959-2.7365-7.8145v-.0025Z"
	})
});
export default SvgQuantum;
